import React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import DestructiveButton from '../controls/DestructiveButton';
import { useForceUpdate, numberToLetter } from '../util';
import { Content } from '../DataStructures';
import { TabContextReporter } from '../TabContext';
import NumericInput from 'react-numeric-input';
export default function TaskCarousel(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Panel Overview"
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Number of Panels:")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumericInput, {
    min: 2,
    max: 5,
    value: dataProps.items.length,
    onChange: e => {
      if (e) {
        let delta = e - dataProps.items.length;
        if (delta > 0) {
          for (let i = 0; i < Math.abs(delta); ++i) {
            dataProps.items.push(new Content("Lorem ipsum dolor sit amet"));
          }
        } else if (delta < 0) {
          for (let i = 0; i < Math.abs(delta); ++i) {
            dataProps.items.pop();
          }
        }
        forceUpdate();
        props.onChanged();
      }
    }
  })))), dataProps.items.map((child, index) => {
    const letter = numberToLetter(index);
    return /*#__PURE__*/React.createElement(TabContextReporter, {
      index: String(index + 1),
      title: "Panel " + String(index + 1)
    }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, "Slide ", letter)), /*#__PURE__*/React.createElement(Col, {
      xs: "auto"
    }, dataProps.items.length > 1 && /*#__PURE__*/React.createElement(DestructiveButton, {
      size: "sm",
      variant: "danger",
      title: "Remove slide",
      text: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-trash"
      }),
      confirmation: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-question-lg"
      }),
      className: "fs-sm",
      onClick: () => {
        dataProps.items.splice(index, 1);
        props.decrementActiveTab();
        forceUpdate();
        props.onChanged();
      }
    }))), /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "primary",
      onClick: () => {
        console.log(props.data, ["props", "items", index]);
        let fullPath = props.path.slice();
        fullPath.push("props", "items", index);
        props.scopeToItem(fullPath);
      }
    }, "Edit Slide ", letter), /*#__PURE__*/React.createElement("hr", null))));
  }));
}
TaskCarousel.getHierarchyPaths = root => {
  return root.props.items.map((v, i) => {
    return ["Slide " + (i + 1), ["props", "items", i]];
  });
};